import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import {
  BORDER,
  CHART_POSITIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

interface AmountBarChartProps {
  caption: string;
  data: Array<{ label: string; value: number }>;
  /** Tooltip series label. */
  seriesName: string;
  color?: string;
  active?: string;
  breakdown?: string;
  chartType?: string;
}

/**
 * A single-series monthly bar chart for dollar-amount metrics (ASP, average
 * expansion/contraction/churn/reactivation). Defaults to the gain green; pass a
 * color for loss-side averages (contraction, churn).
 */
const AmountBarChart = ({
  caption,
  data,
  seriesName,
  color = CHART_POSITIVE,
  active = "6M",
  breakdown = "No breakdown",
  chartType = "Bar",
}: AmountBarChartProps) => (
  <MetricChartFrame caption={caption} chartType={chartType} breakdown={breakdown} active={active}>
    <BarChart data={data} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), seriesName]}
      />
      <Bar dataKey="value" fill={color} radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCompactCurrency(Number(v))}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default AmountBarChart;
